
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/about-fhs-world",
      function () {
        return require("private-next-pages/world/about-fhs-world.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/about-fhs-world"])
      });
    }
  